import { PrefDefaults, PrefKey } from '@standardnotes/snjs';
export const LOCALE_COOKIE_NAME = 'sn_locale';
const LOCALE_LOCAL_STORAGE_KEY = 'sn-locale';
const PENDING_LOCALE_SWITCH_KEY = 'sn-pending-locale-switch';
const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
function isFileProtocol() {
    return typeof window !== 'undefined' && window.location.protocol === 'file:';
}
function readLocaleFromLocalStorage() {
    try {
        const value = localStorage.getItem(LOCALE_LOCAL_STORAGE_KEY);
        return value || undefined;
    }
    catch {
        return undefined;
    }
}
function writeLocaleToLocalStorage(locale) {
    try {
        localStorage.setItem(LOCALE_LOCAL_STORAGE_KEY, locale);
    }
    catch {
        // Ignore quota / privacy errors
    }
}
export function getLocaleCookie() {
    if (typeof document === 'undefined') {
        return undefined;
    }
    const prefix = `${LOCALE_COOKIE_NAME}=`;
    const entry = document.cookie
        .split(';')
        .map((part) => part.trim())
        .find((part) => part.startsWith(prefix));
    if (!entry) {
        return undefined;
    }
    const value = decodeURIComponent(entry.slice(prefix.length));
    return value || undefined;
}
export function setLocaleCookie(locale) {
    if (typeof document === 'undefined') {
        return;
    }
    document.cookie = `${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)}; path=/; max-age=${LOCALE_COOKIE_MAX_AGE_SECONDS}; samesite=lax`;
}
/** Persists locale for the next page load. Electron `file://` cannot rely on cookies. */
export function persistLocale(locale) {
    if (isFileProtocol()) {
        writeLocaleToLocalStorage(locale);
    }
    setLocaleCookie(locale);
}
/** Clears bootstrapped locale storage so Labs off does not leave a saved language choice. */
export function clearPersistedLocale() {
    if (isFileProtocol()) {
        try {
            localStorage.removeItem(LOCALE_LOCAL_STORAGE_KEY);
        }
        catch {
            // Ignore quota / privacy errors
        }
    }
    if (typeof document === 'undefined') {
        return;
    }
    document.cookie = `${LOCALE_COOKIE_NAME}=; path=/; max-age=0; samesite=lax`;
}
export function getPersistedLocale() {
    if (isFileProtocol()) {
        const storedLocale = readLocaleFromLocalStorage();
        if (storedLocale) {
            return storedLocale;
        }
    }
    return getLocaleCookie();
}
export function setPendingLocaleSwitch(locale) {
    try {
        sessionStorage.setItem(PENDING_LOCALE_SWITCH_KEY, locale);
    }
    catch {
        return;
    }
}
export function takePendingLocaleSwitch() {
    try {
        const locale = sessionStorage.getItem(PENDING_LOCALE_SWITCH_KEY);
        sessionStorage.removeItem(PENDING_LOCALE_SWITCH_KEY);
        return locale || undefined;
    }
    catch {
        return undefined;
    }
}
export function getSavedLocaleForApplication(application) {
    var _a;
    return (_a = getPersistedLocale()) !== null && _a !== void 0 ? _a : application.getPreference(PrefKey.Locale, PrefDefaults[PrefKey.Locale]);
}
